export default {"src":"/_next/static/media/google-logo.ebc55bca.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};